import SubordinatesWorkloadConstants from '@/store/modules/subordinatesWorkload/constants';

export default {
  [SubordinatesWorkloadConstants.mutationTypes.setSubordinates](state, subordinates) {
    const localState = state;

    localState.subordinates = subordinates;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubordinateInfo](state, info) {
    const localState = state;

    localState.selectedSubordinateInfo = info;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubrodinatesLoading](state, loading) {
    const localState = state;

    localState.subordinatesLoading = loading;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubrodinateInfoLoading](state, loading) {
    const localState = state;

    localState.subordinateInfoLoading = loading;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setUpdatingSubordinateSubscription](state, loading) {
    const localState = state;

    localState.updatingSubscription = loading;
  },

  [SubordinatesWorkloadConstants.mutationTypes
    .setSelectedSubordinateId](state, id) {
    const localState = state;

    localState.selectedSubordinateId = id;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubordinatesTotal](state, total) {
    const localState = state;

    localState.subordinatesTotal = total;
  },
  [SubordinatesWorkloadConstants.mutationTypes.setShowSideBar](state, show) {
    const localState = state;

    localState.showSideBar = show;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubordinatesClientsLoading](state, loading) {
    const localState = state;

    localState.subordinatesClientsLoading = loading;
  },

  [SubordinatesWorkloadConstants.mutationTypes.setSubordinatesClients](state, clients) {
    const localState = state;

    localState.subordinatesClients = clients;
  },
};
